import { createContext } from 'react'

//Util
import { LANGUAGE_ENGLISH } from 'util/constants'

export const LanguageContext = createContext(LANGUAGE_ENGLISH)

export const AvailableLanguagesContext = createContext<string[]>([])